import { useEffect } from 'react';
import { shallow } from 'zustand/shallow';
import { View, useWindowDimensions } from 'react-native-web';
import { DayFilter } from '@rivallapp/volosports-components';

import { MainTabEnum } from '../../shared/discover-tabs-enum';
import {
  SubTabBar,
  MainTabBar,
  SelectACity,
  DiscoverResults,
  TopSportsIconsFilter,
  PopFilterBar,
  TotalWithFeesToggle,
} from './components';
import useDiscoverStore, { DiscoverActions } from '../../zustand-stores/DiscoverStore';
import toggleArrayItem from '../../zustand-stores/DiscoverStore/utils/toggleArrayItem';
import getResultsListWidth from './utilities/getResultsListWidth';
import responsiveStyle from './styles/styles';
import { Button } from '../../shared-components/base-components';
import { DiscoverDateFilter } from './components/DiscoverFilters/components';
import { useUrlParams } from '../../hooks';
import { screenBreakpoints } from '../../shared-components/constants';

const { toggleShowMobileFilters, updateStoreWithUrlParams, updateFilterCollapsed } =
  DiscoverActions;

const DiscoverBody = () => {
  const { isDaily, view, cityName, selectedDaysOfWeek } = useDiscoverStore(
    store => ({
      isDaily: store.isDaily,
      view: store.view,
      cityName: store.filters.cityName,
      selectedDaysOfWeek: store.filters.selectedDaysOfWeek,
    }),
    shallow
  );

  const isRental = view === MainTabEnum.COURT_RENTALS;

  const { urlParams, updateUrlParams } = useUrlParams();

  useEffect(() => updateStoreWithUrlParams(urlParams), [urlParams]);

  const layout = useWindowDimensions();
  const styles = responsiveStyle(layout, screenBreakpoints.lg);
  const screenBreakpointMet = layout.width < screenBreakpoints.lg;
  const resultBodyStyle = getResultsListWidth(layout);

  const onPressDayOfWeek = day => {
    if (!selectedDaysOfWeek.includes(day)) updateFilterCollapsed('selectedDaysOfWeek', false);
    updateUrlParams({ daysOfWeek: toggleArrayItem(selectedDaysOfWeek, day) });
  };

  return (
    <View style={styles('bodyContainer')}>
      {!cityName ? (
        <SelectACity />
      ) : (
        <View style={resultBodyStyle}>
          <MainTabBar />
          <TopSportsIconsFilter />
          <SubTabBar />
          {screenBreakpointMet ? (
            <View style={styles('toggleFiltersToolbar')}>
              {isDaily || isRental ? <DiscoverDateFilter /> : null}
              <Button
                thin
                value="FILTERS"
                textStyle={styles('toggleFiltersButton')}
                onPress={() => toggleShowMobileFilters()}
              />
            </View>
          ) : null}
          <DayFilter
            squared
            hideTitle
            optStyles={getResultsListWidth(layout)}
            selectedDays={selectedDaysOfWeek}
            onPress={value => onPressDayOfWeek(value)}
          />
          <PopFilterBar />
          <TotalWithFeesToggle />
          <DiscoverResults />
        </View>
      )}
    </View>
  );
};

export default DiscoverBody;
